import React from 'react';
import { Link } from 'react-router-dom';

const ContainerGridItem = ({
  container,
  activeCount,
  inactiveCount,
  shown,
}) => {
  const { active, id, slug, name } = container;

  return (
    <div
      className={'item container ' + (active ? 'active' : 'inactive')}
      style={{
        opacity: shown ? '1' : '0',
        transition: `opacity 0.5s ease`,
      }}
    >
      <Link to={`/manage/containers/${id}`} className='item-link'>
        <div className='cargo'>
          <div className='name'>{name}</div>
          <div>
            <span className='meta-badge'>{slug}</span>
          </div>
          <div className='count'>
            <span className='active' title='Active Forms'>
              {activeCount}
            </span>
            <span className='inactive' title='Inactive Forms'>
              {inactiveCount}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ContainerGridItem;
